/**
 * Códigos que el panel de operadores del seller muestra y manda al guardar.
 *
 * `handleSavePermissions` filtra el payload por esta lista, así que un código que
 * falte acá se puede llegar a renderizar pero nunca se persiste. Tiene que quedar
 * alineada con los `permissionCodes` de los grupos `individually` del panel.
 */
export const requiredCodes = [
  "store_linked_seller",
  "seller_permission",
  "linked_products",
  "seller_config",
  "optimizer_config",
];
